/* eslint-disable */
import React, { useState, useEffect, useRef, useContext } from "react";
import "./index.css";
import MyContext from "../Mycontext";
import send from "../../../static/icon/send.png";
import sendTrue from "../../../static/icon/sendlogo.svg";

import { Form } from "react-bootstrap";
import {
	CloseCircleOutlined,
	FileImageOutlined,
	PlusOutlined,
	PlusSquareTwoTone,
} from "@ant-design/icons";

import { CN_TEXT, US_TEXT } from "../../../config";
import axios from "axios";
import { Image, message, Upload, Button, UploadProps } from "antd";
import { baseURL } from "../../../api/Request";
import { useTranslation } from "react-i18next";

function Chatting() {
	const [text, setText] = useState("");
	const textareaRef = useRef<HTMLTextAreaElement>(null);
	const [isComposing, setIsComposing] = useState(false);
	const [previewOpen, setPreviewOpen] = useState(false);
	const { t, i18n } = useTranslation();

	useEffect(() => {
		if (textareaRef.current) {
			textareaRef.current.style.height = "22px";
			textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
		}
	}, [text]);

	const context = useContext(MyContext);
	if (!context) {
		return null; // 处理无法获取到 Context 的情况
	}
	const {
		isInputValue,
		selectedChat,
		setIsInputValue,
		setSelectedChat,
		requireType,
		isLoad,
		handleChange,
		file,
		setFile,
		setFileUrl,
		current,
		conversationId,
		chatListData,
		listen,
		setListen,
	} = context;

	const endRef = useRef<any>(null);
	const placeholders = [
		"我想要10条XXX数据",
		"搜索XXX数据",
		"请帮我生成XXX数据",
	];
	const [placeholder, setPlaceholder] = useState(placeholders[0]);
	const [index, setIndex] = useState(0);

	useEffect(() => {
		setTimeout(() => {
			endRef.current?.scrollIntoView({ behavior: "smooth" });
		}, 50);
	}, [
		selectedChat,
		// inputValue,
		// chatListData,
		// current,
		// isInputValue,
		conversationId,
		isLoad,
	]);

	useEffect(() => {
		setTimeout(() => {
			endRef.current?.scrollIntoView({ behavior: "smooth" });
		}, 1000);
	}, [listen]);

	useEffect(() => {
		const interval = setInterval(() => {
			setIndex((prevIndex: any) => {
				const nextIndex = (prevIndex + 1) % placeholders.length;
				setPlaceholder(placeholders[nextIndex]);
				return nextIndex;
			});
		}, 2000); // 每2秒切换一次

		return () => clearInterval(interval); // 清除定时器
	}, []);

	const user = localStorage.getItem("user");
	const userInfo = user ? JSON.parse(user) : null;

	const handleInputChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
		setText(event.target.value);
	};

	const onDelete = () => {
		setFile(null); // 删除图片
		setFileUrl("");
	};

	const handleFileUpload = async (file: any) => {
		const formData = new FormData();
		formData.append("file", file);

		try {
			const response = await axios.post(
				`${baseURL}/file-upload/tmp-upload`,
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
						Authorization: "Bearer " + localStorage.getItem("token"),
					},
				}
			);

			if (response?.data) {
				setFileUrl(response?.data?.message);
				handleChange(text, response?.data?.message);
			}

			if (response.status === 200) {
				// message.success("上传成功");
			}
		} catch (error) {
			message.error("上传失败");
		}
	};

	const retInput = () => {
		// console.log("retInputretInputretInputretInputretInput");
		if (file != null) {
			handleFileUpload(file);
			// setIsInputValue(true);
		} else if (text != "") {
			handleChange(text);
			// setIsInputValue(true);
		}

		setFile(null);
		setFileUrl("");
		setText("");
	};

	// 切换对话框时清空值
	useEffect(() => {
		setText("");

		setFile(null);
		setFileUrl("");
	}, [selectedChat]);

	const props: UploadProps = {
		action: "",
		listType: "picture",

		fileList: [],
		onChange: (info) => {
			console.log("===info", info);
			setFile(info?.file?.originFileObj);
			// console.log(info.fileList);
		},
	};

	const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === "Enter") {
			console.log("触发回车");
			e.preventDefault(); // 阻止默认的 Enter 操作
			if (e.shiftKey) {
				// 处理 Shift+Enter 换行逻辑
				// setMessage(message + '\n');
				setText(text + "\n");
			} else if (!isComposing) {
				// 处理 Enter 发送逻辑
				retInput();
			}
		}
	};

	// 判断是否是中文输入法
	const handleCompositionStart = () => {
		setIsComposing(true);
	};
	const handleCompositionEnd = () => {
		setIsComposing(false);
	};

	return (
		<>
			<div className="endChat" ref={endRef}></div>

			<div className="Chatting">
				<div className="Chatting-input-box">
					<div className="Chatting-input-box-upFils">
						{requireType == "img" && (
							<Upload {...props}>
								<Button icon={<PlusOutlined />}></Button>
							</Upload>
						)}
					</div>

					<div className="Chatting-input-conter">
						{/* 图片区域 */}
						{file && (
							<div className="form-image-wrapper">
								<Image
									src={URL.createObjectURL(file)}
									alt="Preview"
									style={{
										maxWidth: "50px",
										maxHeight: "50px",
										// height: "auto",
										display: "block",
										marginTop: "2px",
										objectFit: "contain",
										borderRadius: "10px",
									}}
									// wrapperStyle={{ borderRadius: "10px" }}
									preview={{
										visible: previewOpen,
										onVisibleChange: (visible) => setPreviewOpen(visible),
										afterOpenChange: (visible) => !visible,
										// && setPreviewImage(""),
									}}
								/>
								<div
									onClick={onDelete}
									style={{
										position: "absolute",
										top: 10,
										left: 50,
										cursor: "pointer",
									}}
								>
									<CloseCircleOutlined
										style={{
											fontSize: 20,
											color: "#ff4d4f",
											backgroundColor: "rgba(255, 255, 255, 0.7)",
											borderRadius: "50%",
										}}
									/>
								</div>
							</div>
						)}
						<div className="placeholder-wrapper">
							<Form.Control
								// disabled={isInputValue || current.length > 0}
								as="textarea"
								// placeholder={
								// 	i18n.language == "en"
								// 		? US_TEXT.INPUTPLACEHOLDER
								// 		: CN_TEXT.INPUTPLACEHOLDER
								// }
								placeholder={placeholder}
								className="Chatting-input scroll-bar-style"
								onChange={handleInputChange}
								ref={textareaRef}
								value={text}
								onKeyDown={handleKeyDown}
								onCompositionStart={handleCompositionStart}
								onCompositionEnd={handleCompositionEnd}
							/>
							<div
								className="Chatting-input-sending-btn"
								onClick={() => {
									retInput();
								}}
							>
								<img
									src={
										(text != "" || file != null) && current.length == 0
											? sendTrue
											: send
									}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default Chatting;
